import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InquiryChat = () => {
  const navigate = useNavigate();

  // Generate or retrieve Device ID (UUID) from localStorage
  const getDeviceId = () => {
    let deviceId = localStorage.getItem('dws_device_id');
    if (!deviceId) {
      deviceId = 'dev_' + crypto.randomUUID();
      localStorage.setItem('dws_device_id', deviceId);
    }
    return deviceId;
  };

  useEffect(() => {
    const initInquiry = async () => {
      try {
        const deviceId = getDeviceId();

        // --- Fast path: if we already have a fully-initialized session in
        //     localStorage (i.e. the user closed and re-opened the tab), just
        //     redirect straight to the chat without hitting the server again.
        const existingRaw = localStorage.getItem('inquiry_session');
        if (existingRaw) {
          try {
            const existing = JSON.parse(existingRaw);
            if (existing && !existing.is_pending && existing.guest_user_id && existing.token) {
              // Session looks valid — go straight to the chat
              navigate(`/customer-chat?type=inquiry`, { replace: true });
              return;
            }
          } catch (_) {}
        }

        // --- No valid cached session: call the backend to check / restore ---
        
        // Get client IP (secondary identifier)
        let clientIP = 'Unknown';
        try {
          const ipResponse = await fetch('https://api.ipify.org?format=json');
          const ipData = await ipResponse.json();
          clientIP = ipData.ip;
        } catch (err) {
          console.warn('Could not get IP:', err);
        }
        
        // Check if this device already has an inquiry session
        const checkResponse = await axios.post(`${API}/inquiry/check`, {
          ip_address: clientIP,
          device_id: deviceId
        });
        
        if (checkResponse.data.exists) {
          const { guest_name, guest_user_id, chat_room_id, token, refresh_token, firebase_token, session_id } = checkResponse.data;
          
          const session = {
            guest_name,
            guest_user_id,
            chat_room_id,
            ip_address: clientIP,
            device_id: deviceId,
            is_inquiry: true,
            is_returning: true,
            token,
            refresh_token,
            firebase_token,
            session_id
          };
          localStorage.setItem('inquiry_session', JSON.stringify(session));
        } else {
          const pendingSession = {
            ip_address: clientIP,
            device_id: deviceId,
            referrer: document.referrer || 'Direct',
            is_inquiry: true,
            is_pending: true
          };
          localStorage.setItem('inquiry_session', JSON.stringify(pendingSession));
        }
        
        navigate(`/customer-chat?type=inquiry`, { replace: true });
        
      } catch (error) {
        console.error('Failed to initialize inquiry:', error);
        // Even on error, redirect to chat - will handle error there
        const pendingSession = {
          ip_address: 'Unknown',
          device_id: deviceId,
          referrer: document.referrer || 'Direct',
          is_inquiry: true,
          is_pending: true
        };
        localStorage.setItem('inquiry_session', JSON.stringify(pendingSession));
        navigate(`/customer-chat?type=inquiry`, { replace: true });
      }
    };
    
    initInquiry();
  }, [navigate]);

  // Return empty/transparent div - instant redirect, no visible loading
  return (
    <div className="min-h-screen bg-wa-hover" />
  );
};

export default InquiryChat;
